import { CheckIcon, XIcon } from '@primer/octicons-react';
import { graphql, useFragment } from 'react-relay';

import {
  BrandMessageTemplateConnectionDataTable_brandMessageTemplateConnection$data,
  BrandMessageTemplateConnectionDataTable_brandMessageTemplateConnection$key,
} from '../../../relay/__generated__/BrandMessageTemplateConnectionDataTable_brandMessageTemplateConnection.graphql';
import DataTable, { DataTableProps } from '../../core/DataTable';
import DateText from '../../core/DateText';
import StyledOcticon from '../../core/StyledOcticon';
import Text from '../../core/Text';
import { getBrandMessageTypeLabel } from '../constants';

const BrandMessageTemplateConnectionDataTable_brandMessageTemplateConnection = graphql`
  fragment BrandMessageTemplateConnectionDataTable_brandMessageTemplateConnection on BrandMessageTemplateConnection {
    edges {
      node {
        id
        createTime
        templateCode
        templateName
        serviceStatus
        chatBubbleType
      }
    }
  }
`;

type Props = {
  brandMessageTemplateConnection: BrandMessageTemplateConnectionDataTable_brandMessageTemplateConnection$key;
} & Omit<
  DataTableProps<BrandMessageTemplateConnectionDataTable_brandMessageTemplateConnection$data['edges'][number]['node']>,
  'rows' | 'columns'
>;

const BrandMessageTemplateConnectionDataTable = ({ brandMessageTemplateConnection, ...props }: Props) => {
  const { edges } = useFragment(
    BrandMessageTemplateConnectionDataTable_brandMessageTemplateConnection,
    brandMessageTemplateConnection,
  );

  return (
    <DataTable
      rows={edges.map(({ node }) => node).filter((node) => !!node)}
      columns={[
        {
          field: 'createTime',
          title: '제작일',
          renderValue: ({ createTime }) => <DateText>{createTime}</DateText>,
          width: 80,
        },
        {
          field: 'templateCode',
          title: '템플릿 코드',
          renderValue: ({ templateCode }) => <Text>{templateCode}</Text>,
          width: 200,
        },
        {
          field: 'templateName',
          title: '템플릿 이름',
          renderValue: ({ templateName }) => <Text>{templateName}</Text>,
          width: 200,
        },
        {
          field: 'chatBubbleType',
          title: '메세지 유형',
          renderValue: ({ chatBubbleType }) => <Text>{getBrandMessageTypeLabel(chatBubbleType)}</Text>,

          width: 80,
        },
        {
          field: 'serviceStatus',
          title: '템플릿 검수 상태',
          renderValue: ({ serviceStatus }) =>
            serviceStatus === 'A' ? (
              <StyledOcticon icon={CheckIcon} sx={{ color: 'success.fg' }} />
            ) : (
              <StyledOcticon icon={XIcon} sx={{ color: 'danger.fg' }} />
            ),
          width: 80,
          align: 'center',
        },
      ]}
      {...props}
    />
  );
};

export default BrandMessageTemplateConnectionDataTable;
